import { CONTACT_IMPORT_STATUS } from '@/constants';
import { FC } from 'react';

// Define types for our component
type ImportStatusProps = {
  // Required props
  progress: number;
  status: string;

  title?: string;
};

const ImportStatus: FC<ImportStatusProps> = ({
  progress,
  status,
  title = 'Import Status',
}) => {
  const getBadgeStyles = () => {
    switch (status) {
      case CONTACT_IMPORT_STATUS?.PENDING:
        return {
          text: 'Pending',
          color: 'text-yellow-800 bg-yellow-100',
          animate: '',
        };
      case CONTACT_IMPORT_STATUS?.IN_PROGRESS:
        return {
          text: 'In Progress',
          color: 'text-secondary bg-aliceBlue',
          animate: 'animate-pulse',
        };
      case CONTACT_IMPORT_STATUS?.COMPLETED:
        return {
          text: 'Complete',
          color: 'text-green-800 bg-green-100',
          animate: '',
        };
    }
  };

  // Progress bar color based on state
  const getProgressBarColor = () => {
    switch (status) {
      case CONTACT_IMPORT_STATUS?.PENDING:
        return 'bg-yellow-500';
      case CONTACT_IMPORT_STATUS?.IN_PROGRESS:
        return 'bg-secondary';
      case CONTACT_IMPORT_STATUS?.COMPLETED:
        return 'bg-green-500';
    }
  };

  const badge = getBadgeStyles();

  return (
    <div className='w-full max-w-sm p-2 bg-white rounded-md shadow-sm border border-gray-200'>
      <div className='flex items-center justify-between mb-1'>
        <h3 className='text-sm font-medium text-gray-900'>{title}</h3>
        <span
          className={`px-2 py-0.5 text-xs font-semibold ${badge?.color} rounded-full ${badge?.animate}`}
        >
          {badge?.text}
        </span>
      </div>

      <div className='mb-2'>
        <p className='text-xs text-gray-600'>{badge?.text}</p>
      </div>

      <div className='flex items-center gap-2'>
        <div className='flex-grow bg-gray-200 rounded-full h-2'>
          <div
            className={`h-2 rounded-full ${getProgressBarColor()}`}
            style={{ width: `${progress}%`, transition: 'width 0.3s ease' }}
            data-testid='progress-bar'
          ></div>
        </div>
        <div className='text-xs text-gray-500 whitespace-nowrap'>
          {progress}%
        </div>
      </div>
    </div>
  );
};

export default ImportStatus;
